; (function (window, document, application) {
    'use strict';

    var DEFAULT_OPTIONS = {
        componentSelector: '[data-component="google-map"]',
        mapSelector: '[data-component="map"]',
        locationJsonLdContainerSelector: '[data-component="locations"]'
    }

    var maps = {
        init: function () {
            this.options = $.extend({}, DEFAULT_OPTIONS);
            this.maps = document.querySelectorAll(this.options.componentSelector);
            Array.prototype.forEach.call(this.maps, this.createMap.bind(this));
        },
        createMap: function (element) {
            var options = this._getOptions(element);
            var mapElement = element.querySelectorAll(this.options.mapSelector)[0];

            var map = new google.maps.Map(mapElement, {
                disableDefaultUI: options.disableDefaultUI,
                zoom: options.zoom,
                maxZoom: options.zoom
            });

            var locations = this._getLocations(element);
            
            var markers = this._createMarkers(map, locations);

            if (options.fitBounds) {
                this._fitBounds(map, markers);
            }

            if (options.initialMaxZoom) {
                google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
                    map.setZoom(Math.min(options.initialMaxZoom, map.getZoom()));
                });
            }
        },
        _createMarkers: function(map, locations) {
            var locationCount = locations.length;
            var markers = [];

            for (var i = 0; i < locationCount; i++) {
                var location = locations[i];
                
                var marker = new google.maps.Marker({
                    position: {
                        lat: location.geo.latitude,
                        lng: location.geo.longitude
                    },
                    map: map
                });

                markers.push(marker);
            }

            return markers;
        },
        _fitBounds: function (map, markers) {
            var bounds = new google.maps.LatLngBounds();
            var markerCount = markers.length;

            for (var i = 0; i < markerCount; i++) {
                var marker = markers[i];
                
                bounds.extend(marker.getPosition());
            }

            map.fitBounds(bounds);
        },
        _getLocations: function(element) {
            var locationsContainerElement = element.querySelectorAll(this.options.locationJsonLdContainerSelector);

            return JSON.parse(locationsContainerElement[0].innerHTML);
            
        },
        _getOptions: function (element) {
            return {
                disableDefaultUI: element.getAttribute('data-disableDefaultUI') || false,
                fitBounds: element.getAttribute('data-fitBounds') || false,
                zoom: parseFloat(element.getAttribute('data-zoom') || 0),
                initialMaxZoom: parseFloat(element.getAttribute('data-initialMaxZoom') || 0)
            };
        }
    };

    application.maps = maps;
})(window, document, application = window.application || {});